module.exports = "/_next/static/images/Privacy-md-f5a71df4e72cd552ffb1cb28fb3c5be5.png";